import React from "react";
import { MdEmail } from "react-icons/md";
import { BsGithub } from "react-icons/bs";
import { BsInstagram } from "react-icons/bs";
import { AiFillLinkedin } from "react-icons/ai";

const Footer = () => {
  return (
    <>
      <div className=" h-72 bg-slate-950">
        <div className=" py-10 text-gray-200 text-center">
          <h1 className="text-4xl lg:text-5xl">Get In Touch</h1>
          <p className="mt-4">Greater Noida, India</p>
        </div>

        <div className="text-4xl mt-5 flex justify-center gap-16 text-gray-600 dark:text-gray-300 ">
          <a
            className="transition-all hover:scale-110 hover:text-red-600 duration-250"
            href="mailto:animesh8492@gmail.com"
            target="_blank"
            rel="noreferrer"
          >
            <MdEmail />
          </a>
          <a
            className="transition-all hover:scale-110 hover:text-blue-600 duration-250"
            href="https://www.linkedin.com/in/animesh-sharma-a74595250/"
            target="_blank"
            rel="noreferrer"
          >
            <AiFillLinkedin />
          </a>
          <a
            className="transition-all hover:scale-110 hover:text-gray-100 duration-250"
            href="https://github.com/hashZero1"
            target="_blank"
            rel="noreferrer"
          >
            <BsGithub />
          </a>
          <a
            className="transition-all hover:scale-110 hover:text-pink-600 duration-250"
            href="https://www.instagram.com/57_pixels._/"
            target="_blank"
            rel="noreferrer"
          >
            <BsInstagram />
          </a>
        </div>
      </div>
    </>
  );
};

export default Footer;
